import { API_URLS } from "@/api/urls";
import axiosInstance from "@/inteceptors";
import { useQuery } from "@tanstack/react-query";

export const useGetCountries = () => {
  return useQuery<Country[]>({
    queryKey: ["countries"],
    queryFn: async () => {
      const response = await axiosInstance.get(API_URLS.SETTINGS.COUNTRIES);
      return response.data;
    },
  });
};
